import { render, staticRenderFns } from "./SetAttendance.vue?vue&type=template&id=539b5670&"
import script from "./SetAttendance.vue?vue&type=script&lang=js&"
export * from "./SetAttendance.vue?vue&type=script&lang=js&"
import style0 from "./SetAttendance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports